import React from "react";
import { SuccessScreenScreenWithBookingData } from "~/features/book-appointment/SuccessScreen";

const Component = () => {
  return <SuccessScreenScreenWithBookingData />;
};

export default Component;
